/* eslint-disable no-unused-vars */
import React from "react";
import { ScalableImage } from "design_system/src";

export const ImmersiveFooter: React.FC = () => {
  return (
    <footer className="bg_neutral_900">
      <div className="dso_container">
        <div className="m_y_sm">
          <div className="display_flex flex_align_center h_40_px">
            <ScalableImage
              src="https://ik.imagekit.io/ozon/Compartidos/Logos/logo_ozon_blanco"
              desktopWidth={10}
              mobileWidth={5}
              className="img_contain"
              alt="Logo Ozon – Plataforma de financiamiento de motos nuevas y seminuevas en CDMX"
            />
          </div>
        </div>
      </div>
    </footer>

  );
};
